<style lang="scss" scoped>
@import "core";

.my-lead {
  margin-bottom: 15px;
  color: $color-strong;
}
</style>



<template>
  <error-dialog-base ref="base">
    <div slot="header">お使いのブラウザでは<wbr>このページを<wbr>表示できません。</div>
    <div slot="message" is="template">以下のブラウザでこのページを表示可能です。</div>
    <my-compatibleTable />
  </error-dialog-base>
</template>



<script>
import DialogMixin from './dialogMixin';
import CompatibleTable from './partials/CompatibleTable';



export default {
  mixins: [DialogMixin],

  components: {
    'my-compatibleTable': CompatibleTable,
  },
}
</script>



// WEBPACK FOOTER //
// DialogNotCompatibleError.vue?6cc2be52